import InfoCard from "./InfoCard";
import Styles from "../../../scss/orderDetails.module.scss";
import { useTranslation } from "react-i18next";

interface IProps {
    method: string;
}
// eslint-disable-next-line
export enum EPaymentMethods {
    CARD = "CARD",
    APPLE_PAY = "APPLE_PAY",
    GOOGLE_PAY = "GOOGLE_PAY",
    BANK_TRANSFER = "BANK_TRANSFER"
}
export function PaymentMethods({ method }: IProps) {
    const { t } = useTranslation();
    const value = t("orderHistory.paymentTypes." + method);
    return <>
        <InfoCard label={t("orderHistory.modal.Paymentmethod")} value={value} className={Styles.BillLabels} />
    </>
}